<template>
  <StudioDropdown
    v-if="workspaceSelectItems?.length"
    :selectedItemIndex="selectedWorkspaceIndex"
    :menuItems="workspaceSelectItems"
    :variant="dropdownVariant"
    @select="handleSelectWorkspaceFilter"
  />
</template>

<script lang="ts">
import { listWorkspace } from '@goldcast/api/backend';
import logger from '@goldcast/logger';
import { defineComponent, PropType } from 'vue';
import { mapGetters, mapActions } from 'vuex';

import { StudioButtonVariant } from '@/studioComponents/StudioButton.vue';
import StudioDropdown, { MenuItem } from '@/studioComponents/StudioDropdown.vue';

export enum DefaultWorkspaceOption {
  AllWorkspaces = '',
  NoWorkspaces = 'no-team'
}

const allWorkspaceSelectItem: MenuItem = {
  id: 0,
  title: 'All Team Workspaces',
  value: DefaultWorkspaceOption.AllWorkspaces
};

const noWorkspaceSelectItem: MenuItem = {
  id: 1,
  title: 'No Team Workspace',
  value: DefaultWorkspaceOption.NoWorkspaces
};

export default defineComponent({
  name: 'WorkspaceSelectFilter',
  components: { StudioDropdown },
  props: {
    showNoWorkspaceOption: {
      type: Boolean,
      default: false
    },
    dropdownVariant: {
      type: String as PropType<StudioButtonVariant>,
      default: 'filled'
    },
    selectedWorkspace: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoadingWorkspaces: false,
      workspaceSelectItems: [] as MenuItem[],
      selectedWorkspaceIndex: 0
    };
  },
  mounted() {
    this.fetchWorkspaces();
  },
  computed: {
    ...mapGetters('org', {
      currentOrg: 'getCurrentOrg'
    })
  },
  methods: {
    ...mapActions('studioToast', {
      triggerToast: 'triggerToast'
    }),
    handleSelectWorkspaceFilter(index: number) {
      this.selectedWorkspaceIndex = index;
      this.$emit('onSelectWorkspaceFilter', this.workspaceSelectItems[index].value);
    },
    async fetchWorkspaces() {
      this.isLoadingWorkspaces = true;
      try {
        const workspaces = await listWorkspace({
          queryParams: {
            organization: this.currentOrg.id,
            show: 'mine'
          }
        });

        this.workspaceSelectItems.push(allWorkspaceSelectItem);
        if (this.showNoWorkspaceOption) {
          this.workspaceSelectItems.push(noWorkspaceSelectItem);
        }

        const offset = this.workspaceSelectItems.length;

        if (Array.isArray(workspaces)) {
          workspaces.forEach((workspace, index) => {
            this.workspaceSelectItems.push({
              id: index + offset,
              title: workspace.name,
              value: workspace.id
            });
          });
        }

        if (this.selectedWorkspace) {
          this.selectedWorkspaceIndex = this.workspaceSelectItems.findIndex(
            item => item.value === this.selectedWorkspace
          );
        }
      } catch (error) {
        this.triggerToast({
          mode: 'error',
          msg: 'Failed to fetch team workspaces'
        });
        logger.warn('WorkspaceSelectFilter: fetch team workspaces failed', { error });
      } finally {
        this.isLoadingWorkspaces = false;
      }
    }
  }
});
</script>
